<section class="accounts">
  <h2 class="section-title">Your accounts</h2>
  @if (loanAccountRows().length > 0) {
    <app-account-card-v2 title="Loan accounts">
      @for (row of loanAccountRows(); track row.account.id; let idx = $index) {
        <app-loan-account-item
          (onClickLoanCard)="clickLoanCard($event)"
          (onClickLoanMakePayment)="clickLoanMakePayment($event)"
          (onClickChangeDueDate)="clickChangeDueDate($event)"
          [account]="row.account"
          [autoPay]="row.autoPay"
          [baseUrl]="loanUrl()"
        >
        </app-loan-account-item>
      }
    </app-account-card-v2>
  }
  @if (cardAccounts().length > 0) {
    <app-account-card-v2 title="Card accounts">
      @for (acct of cardAccounts(); track $index; let idx = $index) {
        <app-card-account-item
          (onClickCreditCard)="clickCreditCard($event)"
          [account]="acct"
          [attr.data-test-id]="'card-account-' + (idx + 1)"
        ></app-card-account-item>
      }
    </app-account-card-v2>
  }
  @if (cardAccounts().length === 0 && loanAccounts().length === 0) {
    <section class="account-card-placeholder">
      <a
        href="https://www.bestegg.com"
        target="_blank"
        rel="noopener"
        class="account-card-placeholder__content"
      >
        <app-icon-arrow [width]="'24'" [height]="'24'"></app-icon-arrow>
        <span class="account-card-placeholder__content-text"
          >Explore Our Products</span
        >
      </a>
    </section>
  }
</section>
